// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"e036434daed0b6ecb09c","274":"205c0cdcfa6532a73045","378":"464a66e036a266986fb3","413":"80ea9db484921a7cf98c","673":"63802957570e56a1812b"}[chunkId] + ".css";
};